import type { ExperimentKeyValue, ExperimentResult } from "@rflocal/shared/experiments";

type ExperimentEvaluationContext = { distinctId?: string; groups?: Record<string, string> };

/**
 * Evaluate an experiment via the backend.
 *
 * Calls GET /query/experiment which evaluates the flag server-side through
 * posthog-node, making it adblocker-proof.
 */
export async function getExperiment(
    key: ExperimentKeyValue,
    context: ExperimentEvaluationContext
): Promise<ExperimentResult> {
    const params = new URLSearchParams({ key });
    if (context.distinctId) {
        params.set("distinctId", context.distinctId);
    }

    const workspaceId = context.groups?.workspace;
    if (workspaceId) {
        params.set("workspaceId", workspaceId);
    }

    const response = await fetch(`/query/experiment?${params}`);

    if (!response.ok) {
        throw new Error(`ExperimentApiError: ${response.status}`);
    }

    return response.json();
}

export default { getExperiment };
